<template>
    <!--
        latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
        BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
    -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <div class="c-jhs-free-guidance-login">
            <jhs-free-heading />
            <div class="l-element">
                <h3 class="c-jhs-free-guidance-login-title"><img :src="imageUrl('img_login_menu01_title.svg')" alt="ピクトリンクの会員ですか？"></h3>
                <section class="c-jhs-free-guidance-login-section c-jhs-free-guidance-login-section_login">
                    <h4>
                        <img :src="imageUrl('img_login_menu02_title.svg')" alt="無料会員・プレミアム会員の方 プリGETしたことがある方はこっち！">
                    </h4>
                    <div class="c-jhs-free-guidance-login-btn" @click="nextWithAfterUrl(loginUrl, 'ログインして申し込む')" data-jest="login-link">
                        <img :src="imageUrl('btn_login_menu02.png')" alt="ログインして申し込む">
                    </div>
                </section>
                <section class="c-jhs-free-guidance-login-section c-jhs-free-guidance-login-section_register">
                    <h4>
                        <img :src="imageUrl('img_login_menu03_title00.svg')" alt="無料会員・プレミアム会員ではない方">
                    </h4>
                    <div class="c-jhs-free-guidance-login-btn" @click="nextWithAfterUrl(registerUrl, '会員登録して申し込む')" data-jest="register-link">
                        <img :src="imageUrl('btn_login_menu03.svg')" alt="会員登録して申し込む">
                    </div>
                    <p><img :src="imageUrl('img_login_menu03_title01.svg')" alt="無料で会員登録できます"></p>
                </section>
                <p class="c-jhs-free-guidance-login-info">※申し込みにはピクトリンクの会員登録（無料）が必要です。</p>
            </div>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import JhsFreeHeading from "../../molecules/JhsFreeHeading.vue";
import * as urlUtil from "../../../util/UrlUtil"
import {setAfterUrl} from "../../../model/action/AfterUrlAction";
import {getClickAllEvent} from "../../../util/Ga4EventUtil";
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";

export default {
    name: "JhsFreeGuidanceLogin",
    components: {BaseLayout, JhsFreeHeading},
    props: {
        /**
         * title
         */
        title: {
            type: String,
            required: true
        },
        /**
         * description
         */
        description: {
            type: String,
            required: true
        },
    },
    data() {
        // OIDCログインは _pictlink_after_login_url Cookie を読まず
        // returnTo クエリで戻り先を決めるため、Cookie(setAfterUrl)とあわせて returnTo も渡す。
        // ただし returnTo のフラグメント(#/input/profile)はログイン後のリダイレクトで失われるため、
        // 遷移するのは申込情報入力画面ではなく中学生無料のLP(/sp/jhs_free#/lp)になる。
        const afterUrl = urlUtil.servletUrlUtil.inputProfileUrl()
        const returnToQuery = `?returnTo=${encodeURIComponent(afterUrl)}`
        return {
            headerType: headerType,
            footerType: footerType,
            imgUrl: '/img/jhs_free/guidance_login/',
            loginUrl: urlUtil.servletUrlUtil.loginUrl() + returnToQuery,
            registerUrl: urlUtil.servletUrlUtil.registrationUrl() + returnToQuery,
            afterUrl: afterUrl
        }
    },
    mounted() {
        this.setTitleAndDesc()
    },
    methods: {
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        next(nextUrl) {
            location.href = nextUrl
        },
        async nextWithAfterUrl(nextUrl, elementText) {
            getClickAllEvent(nextUrl, elementText)
            await setAfterUrl(this.afterUrl)
            this.next(nextUrl)
        },
        imageUrl(fileName) {
            return urlUtil.imageUrlUtil.buildImageUrl(this.imgUrl + fileName);
        }
    }
}
</script>

<style scoped lang="scss">
@use "../../../../scss/v2/base/variables";
@use "sass:math";

// ベースとなるデバイス幅
$grid-device-width: 375px;
// 余白
$grid-base: percentage(math.div(16px, $grid-device-width)); // 16px
$grid-consistent: $grid-base * 0.5; // 8px

:deep(.l-content) {
    background-image: linear-gradient(to bottom, variables.$color-jhs-free-bg-gradation-pink, variables.$color-jhs-free-bg-gradation-beige);
}

.c-jhs-free-guidance-login {
    &-title {
        margin-bottom: $grid-base;
    }
    &-section {
        background: variables.$color-white;
        border-radius: 10px;
        &_login {
            padding: $grid-base 0 $grid-consistent;
            margin-bottom: $grid-base;
        }
        &_register {
            padding: $grid-base 0;
            margin-bottom: $grid-consistent;
        }
    }
    &-btn {
        display: block;
        .c-jhs-free-guidance-login-section_register & {
            width: 168px;
            margin: $grid-base auto $grid-consistent;
        }
    }
    &-info {
        color: variables.$color-white;
        font-size: 1rem;
        line-height: 15px;
    }
}
</style>
